// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__WQKsL","icon":"styles_icon__2izUB"};